import {
  SET_LOADING,
  SET_STEPPER_DATA_SOURCE
} from '@/appLogic/targets/createTarget/store/actions'
import {
  uploadTargetFile,
  uploadFile,
  parseNPowerFile,
  parseComscoreFile,
  checkPIDComplete
} from '@/api'
import Toast from '@/components/common/toasts/'
import RecurringToast from '@/components/common/toasts/RecurringToast'
import {
  ADD_TARGET_TO_TARGET_LIST,
  REFRESH_TABLE
} from '@/views/audienceHub/store/actions'
import {flatten} from '@/helpers'
import {DATASOURCES, TARGET_ACTIONS, TARGET_TYPE, LAS_TYPES} from '@/appLogic/targets/Constants'

export default class UploadTargetFile {
  constructor (context, file, options, target, isAppend) {
    this.context = context
    this.file = file
    this.options = options || {}
    this.target = target
    this.isAppend = isAppend

    this.uploadedBucket = null
    this.uploadedKey = null

    // dont really want this here...
    this.context.commit(SET_LOADING, true)

    const splits = file.name.split('.')
    this.extension = splits[splits.length - 1]
  }

  async run () {
    let resUploadTargetFile = await this.uploadFileAction()
    if (this.options.staged) {
      return resUploadTargetFile
    } else if (this.target.target === TARGET_TYPE.NPOWER || this.target.target === TARGET_TYPE.COMSCORE) {
      return await this.irisProcess()
    } else if (this.newTarget.target === 'pid') {
      return await this.pidListProcess()
    } else {
      this.context.commit(SET_LOADING, false)
      return false
    }
  }

  // TODO need to set the variables
  async _uploadTheFile (signedURL) {
    const rt = new RecurringToast({
      type: 'info',
      title: 'Waiting for File To Upload',
      message: 'Please do not close browser, waiting for file to upload',
      interval: 5000
    })
    rt.start()
    this.context.dispatch(REFRESH_TABLE, false)
    return uploadFile(signedURL, this.file)
    .then(res => {
      rt.stop()
      Toast.success({title: 'File Uploaded', message: `The file ${this.file.name} has been uploaded!`})
      // need to add the target to the list in the Audience Hub if new.

      try {
        if (!this.target.id) this.context.dispatch(ADD_TARGET_TO_TARGET_LIST, this.newTarget)
      } catch (ex) {
        // do nothing here, cause the audience hub could be not activated,
        // if this is done on any page other an the Audience Hub page.
        console.log(ex)
      }
    }).catch(e => {
      this.context.commit(SET_LOADING, false)
      console.error(e)
      Toast.error({
        title: 'Error Uploading File',
        message: `The file ${this.file.name} was not uploaded!`,
        timeout: 10000
      })
    })
  }

  async uploadFileAction () {
    Toast.info({title: 'Uploading File', message: `Uploading file ${this.file.name} now...`})
    return await uploadTargetFile({target: this.target, file: {extension: this.extension}, options: this.options}).then(async (resUploadTargetFile) => {
      this.uploadedBucket = resUploadTargetFile.data.bucket
      this.uploadedKey = resUploadTargetFile.data.key
      if (!this.target.id) Toast.success({title: 'New Target Created', message: `Successfully created new target: ${this.target.display_name}`})
      this.newTarget = resUploadTargetFile.data.target
      await this._uploadTheFile(resUploadTargetFile.data.signedURL)
      return resUploadTargetFile
    }).catch((e) => {
      this.context.commit(SET_LOADING, false)
      console.error(e)
      Toast.error({
        title: 'Error Uploading Target File',
        message: `There was an error uploading the target file.`,
        timeout: 10000
      })
      this.context.commit(SET_LOADING, false)
      return false
    })
  }

  async irisProcess () {
    let parser
    let targetTypeTitle
    let dataprovider

    if (this.target.target === TARGET_TYPE.NPOWER) {
      targetTypeTitle = 'Npower'
      Toast.info({title: 'Parsing File', message: `Parsing NPower file ${this.file.name} now...`, timeout: 10000})
      dataprovider = LAS_TYPES.NPOWER
      parser = parseNPowerFile({bucket: this.uploadedBucket, key: this.uploadedKey})
    } else if (this.target.target === TARGET_TYPE.COMSCORE) {
      Toast.info({title: 'Parsing File', message: `Parsing Comscore file ${this.file.name} now...`, timeout: 10000})
      targetTypeTitle = 'Comscore'
      dataprovider = LAS_TYPES.COMSCORE
      parser = parseComscoreFile({bucket: this.uploadedBucket, key: this.uploadedKey})
    } else {
      throw new Error('Invalid target type for Iris Process')
    }

    return parser.then(res => {
      const irisResponse = res.data
      const MarketDemos = flatten((irisResponse.NetworkMarketDemoGroups || []).map(g => g.QuarterMarketDemoGroups.map(q => q.MarketDemos)))

      if (!irisResponse.ValidationResult.IsValid) {
        this.context.commit(SET_LOADING, false)
        Toast.destroy()
        if (irisResponse.ValidationResult.IsNoSheetsOrCorrupted) {
          Toast.error({
            title: `Error Parsing ${targetTypeTitle} file`,
            message: `The ${targetTypeTitle} file has no sheets or is corrupted`,
            timeout: 10000
          })
          return {Error: `Error Parsing ${targetTypeTitle} file`}
        } else {
          Toast.error({
            title: `Error Parsing ${targetTypeTitle} file`,
            message: irisResponse.ValidationResult.ExcelSheetsValidationInfo.filter(sheetValidationInfo => !sheetValidationInfo.IsValid).map(sheetValidationInfo => `Sheet "${sheetValidationInfo.SheetName}":\n${sheetValidationInfo.ErrorList.join('\n')}`).join('\n'),
            timeout: 10000,
            class: 'mutiline-toast'
          })
          return {Error: `Error Parsing ${targetTypeTitle} file`}
        }
      }

      const utcDateStr = new Date().toISOString()
      const {cae_id, display_name, advertiser} = this.newTarget

      const segmentData = {
        ExcelFileName: irisResponse.FileName,
        DataProvider: dataprovider,
        AudienceSegment: {
          Id: parseInt(cae_id || 0),
          Name: display_name,
          IsActive: true,
          Description: '',
          Advertisers: [{Id: advertiser.Advertiser_id || 0, Name: advertiser.Name, IsActive: true, ProcessedDatetimeUTC: utcDateStr}],
          ProcessedDatetimeUTC: utcDateStr,
          AdvertiserNames: advertiser.Name
        },
        MarketDemos,
        ExcelFileId: irisResponse.FileId
      }
      this.context.commit(SET_LOADING, false)
      return {target: this.newTarget, irisResponse: segmentData}
    }).catch(e => {
      this.context.commit(SET_LOADING, false)
      console.error(e)
      Toast.error({
        title: `Error Parsing ${targetTypeTitle} File`,
        message: `There was an error parsing ${targetTypeTitle} file ${this.file.name}`,
        timeout: 10000
      })
    })
  }

  async pidListProcess () {
    let count = 0
    let that = this
    const runPIDComplete = async function () {
      count += 1
      return checkPIDComplete({target_id: that.newTarget.id}).then(res => {
        const resource = res.data.target_resource
        if (resource) {
          that.context.commit(SET_LOADING, false)
          if (resource.complete) {
            return null
          } else {
            return {
              data: resource.data,
              target: that.newTarget
            }
          }
        } else if (count < 400) {
          const p = new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve(runPIDComplete())
            }, 1000)
          })
          return p
        } else {
          return null
        }
      })
    }
    return await runPIDComplete()
  }

}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/uploadingTarget/UploadTargetFile.js